// extracted by mini-css-extract-plugin
export default {"menu":"SideMenu_menu__tsrtU"};